// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2MGoi","bigColWidth":"Table_bigColWidth__3BWwI","biggerColWidth":"Table_biggerColWidth__1lax9","row":"Table_row__1hykE","col":"Table_col__2qceZ"};